var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "h6",
        {
          staticClass: "headline mb-4",
          staticStyle: { "font-weight": "bold", color: "black !important" }
        },
        [_vm._v("Blogs")]
      ),
      _vm._v(" "),
      _vm.screen_breakpoint
        ? _c(
            "v-layout",
            {
              staticStyle: { "margin-bottom": "-10px" },
              attrs: { row: "", wrap: "" }
            },
            [
              _c("v-flex", { attrs: { lg4: "", md4: "", sm5: "" } }, [
                _c("p", { staticClass: "body-2 ml-2" }, [_vm._v(" Name ")])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { lg1: "", md1: "", "hidden-sm-and-down": "" } },
                [_c("p", { staticClass: "body-2" }, [_vm._v(" Fans ")])]
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { lg6: "", md6: "", sm6: "" } }, [
                _c("p", { staticClass: "body-2" }, [_vm._v(" Notes ")])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.user_info, function(blog) {
        return !_vm.screen_breakpoint
          ? _c(
              "v-layout",
              { key: blog.url, attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "", "mb-3": "" } },
                  [_c("v-divider", { staticClass: "mt-1 mb-1" })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs1: "", "mr-5": "" } },
                  [
                    _c("v-avatar", [
                      _c("img", { attrs: { src: "" + blog.url } })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  [
                    _vm.userIsAuthanticated
                      ? _c(
                          "h6",
                          {
                            staticClass: "headline",
                            staticStyle: {
                              color: "#FF7D27",
                              "margin-top": "-5px",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                _vm.selectBusinessBlog(blog.business_name),
                                  _vm.$router.push("/business")
                              }
                            }
                          },
                          [
                            _vm._v(
                              " \n          " +
                                _vm._s(blog.business_name) +
                                " \n        "
                            )
                          ]
                        )
                      : _c(
                          "h6",
                          {
                            staticClass: "headline",
                            staticStyle: {
                              color: "#FF7D27",
                              "margin-top": "-5px"
                            }
                          },
                          [_vm._v(" " + _vm._s(blog.business_name) + " ")]
                        ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "body-1",
                        staticStyle: { "font-size": ".8em !important" }
                      },
                      [_vm._v(_vm._s(_vm.getPassedTime(blog.upload_date)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "body-1 hidden-md-and-up",
                        staticStyle: {
                          "font-size": ".8em !important",
                          "margin-top": "-15px"
                        }
                      },
                      [_vm._v("Fans: " + _vm._s(blog.follower_count))]
                    ),
                    _vm._v(" "),
                    _vm.user_role === "artist"
                      ? _c(
                          "v-btn",
                          {
                            staticStyle: {
                              "margin-left": "0px",
                              "margin-top": "-10px"
                            },
                            attrs: {
                              depressed: "",
                              small: "",
                              color: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.clicked_business({
                                  userId: blog.userId,
                                  business_email: blog.email,
                                  business_name: blog.business_name
                                })
                              }
                            }
                          },
                          [_vm._v("\n        Select Blog\n      ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { xs12: "" } }, [
                  _c(
                    "p",
                    {
                      staticClass: "body-1",
                      staticStyle: {
                        "font-size": ".85em !important",
                        "margin-top": "0px"
                      }
                    },
                    [
                      _c("strong", [_vm._v("About: ")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(blog.about) + " ")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "body-1",
                      staticStyle: {
                        "font-size": ".85em !important",
                        "margin-top": "-10px"
                      }
                    },
                    [
                      _c("strong", [_vm._v("The Good: ")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(blog.the_good) + " ")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "body-1",
                      staticStyle: {
                        "font-size": ".85em !important",
                        "margin-top": "-10px"
                      }
                    },
                    [
                      _c("strong", [_vm._v("Worth Knowing: ")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(blog.worth_knowing) + " ")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "body-1",
                      staticStyle: {
                        "font-size": ".85em !important",
                        "margin-top": "-10px"
                      }
                    },
                    [
                      _c("strong", [_vm._v("Additional Notes: ")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(blog.additional_notes) + " ")])
                    ]
                  )
                ])
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.user_info, function(blog) {
        return _vm.screen_breakpoint
          ? _c(
              "v-layout",
              { key: blog.url, attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { lg12: "", xs12: "", "mb-3": "" } },
                  [_c("v-divider", { staticClass: "mt-1 mb-1" })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { lg1: "", md1: "", sm1: "", "mb-3": "" } },
                  [
                    _c("v-avatar", [
                      _c("img", { attrs: { src: "" + blog.url } })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { lg3: "", md3: "", sm4: "" } },
                  [
                    _vm.userIsAuthanticated
                      ? _c(
                          "h6",
                          {
                            staticClass: "headline",
                            staticStyle: {
                              color: "#FF7D27",
                              "margin-top": "-5px",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                _vm.selectBusinessBlog(blog.business_name),
                                  _vm.$router.push("/business")
                              }
                            }
                          },
                          [
                            _vm._v(
                              " \n          " +
                                _vm._s(blog.business_name) +
                                " \n        "
                            )
                          ]
                        )
                      : _c(
                          "h6",
                          {
                            staticClass: "headline",
                            staticStyle: {
                              color: "#FF7D27",
                              "margin-top": "-5px"
                            }
                          },
                          [_vm._v(" " + _vm._s(blog.business_name) + " ")]
                        ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "body-1",
                        staticStyle: { "font-size": ".8em !important" }
                      },
                      [_vm._v(_vm._s(_vm.getPassedTime(blog.upload_date)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "body-1 hidden-md-and-up",
                        staticStyle: {
                          "font-size": ".8em !important",
                          "margin-top": "-15px"
                        }
                      },
                      [_vm._v("Fans: " + _vm._s(blog.follower_count))]
                    ),
                    _vm._v(" "),
                    _vm.user_role === "artist"
                      ? _c(
                          "v-btn",
                          {
                            staticStyle: {
                              "margin-left": "0px",
                              "margin-top": "-10px"
                            },
                            attrs: {
                              depressed: "",
                              small: "",
                              color: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.clicked_business({
                                  userId: blog.userId,
                                  business_email: blog.email,
                                  business_name: blog.business_name
                                })
                              }
                            }
                          },
                          [_vm._v("\n        Select Blog\n      ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { lg1: "", md1: "", "hidden-sm-and-down": "" } },
                  [
                    _c("p", { staticClass: "body-2" }, [
                      _vm._v(" " + _vm._s(blog.follower_count) + " ")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { lg6: "", md6: "", sm6: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-flex", { attrs: { lg12: "" } }, [
                          _c(
                            "p",
                            {
                              staticClass: "body-1",
                              staticStyle: {
                                "font-size": ".85em !important",
                                "margin-top": "0px"
                              }
                            },
                            [
                              _c("strong", [_vm._v("About: ")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(blog.about) + " ")])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "body-1",
                              staticStyle: {
                                "font-size": ".85em !important",
                                "margin-top": "-10px"
                              }
                            },
                            [
                              _c("strong", [_vm._v("The Good: ")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(blog.the_good) + " ")])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "body-1",
                              staticStyle: {
                                "font-size": ".85em !important",
                                "margin-top": "-10px"
                              }
                            },
                            [
                              _c("strong", [_vm._v("Worth Knowing: ")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(blog.worth_knowing) + " ")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "body-1",
                              staticStyle: {
                                "font-size": ".85em !important",
                                "margin-top": "-10px"
                              }
                            },
                            [
                              _c("strong", [_vm._v("Additional Notes: ")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(blog.additional_notes) + " ")
                              ])
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44fb09dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fb09dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/blogs.vue
// module id = null
// module chunks = 